<template>
  <div class="vue-component-holder">
    <!--[if lt IE 8]>
    <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/">upgrade your
      browser</a> to improve your experience.</p>
    <![endif]-->

    <!-- Page -->
    <div class="page vertical-align text-center" data-animsition-in="fade-in" data-animsition-out="fade-out">>
      <div class="page-content vertical-align-middle animation-slide-top animation-duration-1">
        <div class="panel">
          <div class="panel-body">
            <div class="brand">
              <img class="brand-img" src="/static/assets/images/repnode-n-logo-colored.svg" alt="...">
            </div>
            <sign-in-form v-if="showSingInForm" @forgotClick="forgotClick" @changeEmail="changeMail"/>
            <forgot-password-form v-if="!showSingInForm" :parentEmail="email"/>
          </div>
        </div>

        <footer class="page-copyright page-copyright-inverse">
          <!--<p>WEBSITE BY Creation Studio</p>-->
          <p>© 2023. All RIGHT RESERVED.</p>
        </footer>
      </div>
    </div>
    <!-- End Page -->


  </div>
</template>

<script>
import SignInForm         from './SignInForm'
import ForgotPasswordForm from './ForgotPasswordForm'
import StaticTranslator   from './../../../model/translator/StaticTranslator'
import DependencyLoader   from '../../../model/loader/user-base-entities-loader'

export default {
  components: { SignInForm, ForgotPasswordForm },
  data () {
    return {
      email:          '',
      title:          'lblSignIn',
      showSingInForm: true,
      translator:     new StaticTranslator()
    }
  },
  created () {
    this.title = this._translate(this.title)

    DependencyLoader.reset()

    document.body.classList.add('animsition')
    document.body.classList.add('page-login-v3')
    document.body.classList.add('layout-full')
    document.body.classList.remove('dashboard')
  },
  methods:    {
    forgotClick () {
      this.showSingInForm = false
      this.title          = this._translate('txtForgotPassword') + ' ?'
    },

    changeMail (email) {
      this.email = email
    },

    /**
     *
     * @param text
     * @return {*}
     */
    _translate (text) {
      return this.translator.translate(text)
    }
  }
}
</script>

<style scoped>
body {
  background: transparent;
}
</style>
